import React from 'react';

const plans = {  
    leftImage:{
        // headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
        button:{textFa:'ورود به پنل مدیریتی', textEn:'Free Trial'},
        textContent:[
            {
                bgIconClass:'bg-orange',
                // headerIcon:<img alt='' src={require('../assets/images/writing.svg')}/>,
                title:{ fa:'وب سرویس پویا ', en:'Pooya API' },
                description:{ 
                    fa:<span>وب سرویس پویا، کلیه اطلاعات معاملاتی لحظه‎ای بازار و تاریخچه آن،
                        اطلاعیه ها، صورت های مالی و مجامع را به همراه اقلام محاسباتی همچون نسبت ها،
                        نرخ های رشد و ضرایب را در اختیار کاربران خود قرار میدهد.<br/><br/>همزمان با انتشار اطلاعیه‎های شرکت‎ها در سامانه کدال،
                        کلیه اطلاعات صورت‎های‎ مالی و اقلام محاسباتی بصورت لحظه‌ای قابل دسترس و استفاده کاربران است. 
                        کلیه اقلام و اطلاعات موجود در سامانه بورس ویو، قابل ارائه در قالب وب سرویس به مخاطبان و کاربران است.<br/></span>
                    , 
                    en:<span>Our team of financial analysts tries to combine the experience of world leaders of data processing 
                        into local need for data to make sure our international clients access world class information which helps 
                        them invest in Iranian companies. Also they test all the pages’ outcome to ensure everything works perfectly 
                        in our desired quality.<br/><br/>Our team of financial analysts tries to combine the experience of world 
                        leaders of data processing into local need for data to make sure our international clients access world class 
                        information which helps them invest in Iranian companies. Also they test all the pages’ outcome to ensure everything 
                        works perfectly in our desired quality.
                    </span>
                },
            }
        ]
    },
    selectableImage:{
        title:{fa:'',en:''},
        description:{fa:'',en:''},
        textContent:[
            {
                bgIconClass:'bg-orange',
                icon:<img alt='' src={require('../assets/images/writing.svg')}/>,
                text:{fa:'اطلاعات بازار و صورت های مالی شرکت ها',
                    en:'Meet the stocks that meet your criteria in a second '},
                img:<img alt='' src={require('../assets/images/pic-3.jpg')} />,
            },
            {
                bgIconClass:'bg-orange',
                icon:<img alt='' src={require('../assets/images/writing.svg')}/>,
                text:{fa:'اطلاعات بازار و صورت های مالی شرکت هنرخ های رشد اقلام کلیدی و اوراق بازار بدهی ',
                    en:'Meet the stocks that meet your criteria in a second '},
                img:<img alt='' src={require('../assets/images/pic-3.jpg')} />,
            },
            {
                bgIconClass:'bg-orange',
                icon:<img alt='' src={require('../assets/images/writing.svg')}/>,
                text:{fa:'آیتم های تکنیکال ریسک و بازده',
                    en:'Meet the stocks that meet your criteria in a second '},
                img:<img alt='' src={require('../assets/images/man-pic-2.jpg')} />,
            }
        ]
    }
}


export default plans;